var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/fork_awesome_icon.tsx";
const _excluded = ["id", "className", "fixedWidth"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * ForkAwesomeIcon: renders a ForkAwesome icon.
 * Full list: https://forkaweso.me/Fork-Awesome/icons/
 * @module soapbox/components/fork_awesome_icon
 * @see soapbox/components/icon
 */

import classNames from 'classnames';
import React from 'react';
const ForkAwesomeIcon = _ref => {
  let {
      id,
      className,
      fixedWidth
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  // Use the Fork Awesome retweet icon, but change its alt
  // tag. There is a common adblocker rule which hides elements with
  // alt='retweet' unless the domain is twitter.com. This should
  // change what screenreaders call it as well.
  // const alt = (id === 'retweet') ? 'repost' : id;

  return /*#__PURE__*/React.createElement("i", _extends({
    role: "img"
    // alt={alt}
    ,
    className: classNames('fa', `fa-${id}`, className, {
      'fa-fw': fixedWidth
    })
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }));
};
export default ForkAwesomeIcon;